var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 282,
    viewBox: "0 0 442 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.25,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "#55B7EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.661 -17.8002C423.372 -16.0436 483.16 9.72367 508.161 60.692C530.038 105.291 489.015 150.947 472.401 197.764C459.723 233.49 457.325 275.087 425.04 294.924C389.36 316.847 345.465 313.466 305.768 300.148C256.953 283.771 204.15 263.129 186.263 214.817C166.107 160.378 178.165 97.437 213.734 51.5725C249.835 5.02059 307.805 -19.6232 366.661 -17.8002Z",
    fill: "#0E1109",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.824 -36.8139C247.512 -35.8944 278.811 -22.4054 291.899 4.27598C303.352 27.6231 281.876 51.5233 273.179 76.0321C266.542 94.734 265.287 116.51 248.386 126.894C229.707 138.37 206.728 136.601 185.946 129.629C160.392 121.056 132.75 110.25 123.386 84.9587C112.834 56.4604 119.147 23.5116 137.767 -0.497978C156.666 -24.8674 187.013 -37.7682 217.824 -36.8139Z",
    fill: "#0E1109",
    fillOpacity: 0.53
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19880"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.25,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.1c6d880b558a08ca9739847b9361793c.svg";
export { ForwardRef as ReactComponent };